var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChina(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_651_7483)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_651_7483",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 0H0V20H20V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_651_7483)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 20C15.5228 20 20 15.5228 20 10C20 4.47716 15.5228 0 10 0C4.47716 0 0 4.47716 0 10C0 15.5228 4.47716 20 10 20Z",
    fill: "#F0263C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.15194 4.58533L2.4873 6.24995L4.15194 7.91458L5.81657 6.24995L4.15194 4.58533Z",
    fill: "#FFD400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.09799 2.49377L6.2583 3.33346L7.09799 4.17315L7.93768 3.33346L7.09799 2.49377Z",
    fill: "#FFD400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.09799 8.32703L6.2583 9.16671L7.09799 10.0064L7.93768 9.16671L7.09799 8.32703Z",
    fill: "#FFD400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.76495 6.66028L7.92529 7.49997L8.76495 8.33965L9.60464 7.49997L8.76495 6.66028Z",
    fill: "#FFD400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.76495 4.16028L7.92529 4.99997L8.76495 5.83965L9.60464 4.99997L8.76495 4.16028Z",
    fill: "#FFD400"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_651_7483"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 10,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChina);
export default __webpack_public_path__ + "static/media/China.e1a63ec545ae59434a8e8a7d76d539fd.svg";
export { ForwardRef as ReactComponent };